<template>
  <div class="contenttop-box">
    <div class="left">
      <div class="en-title">{{ cate.en }}</div>
      <div class="cn-title">{{ cate.title }}</div>
    </div>
    <div
      :class="[index == 0 ? 'center' : 'right']"
      v-for="(item, index) in list"
      :key="index"
      @click="$emit('toInfo', item.id)"
    >
      <div
        :style="
          index == 0
            ? 'width: 18.75rem; height: 13.875rem; overflow: hidden'
            : 'width: 38.75rem; height: 28rem; overflow: hidden'
        "
      >
        <img :src="getImgUrl(item.thumb)" alt="" class="icon hvr-grow" />
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="text">{{ item.describe || "" }}</div>
    </div>
    <!-- <div class="right">
      <div style="width: 38.75rem; height: 28rem; overflow: hidden">
        <img :src="infoData.rightImg" alt="" class="icon hvr-grow" />
      </div>
      <div class="title">{{ infoData.rightTitle }}</div>
      <div class="text">{{ infoData.rightText }}</div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    cate: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      infoData: {
        enTitle: "BRAND",
        cnTitle: "品牌设计",
        centerImg: "",
        centerTitle: "",
        centerText: "",
        rightImg: "",
        rightTitle: "",
        rightText: "",
      },
      indexNum: 1,
    };
  },
  mounted() {
    // switch (this.indexNum) {
    //   case 1:
    //     this.infoData = {
    //       enTitle: "BRAND",
    //       cnTitle: "品牌设计",
    //       centerImg: require("@/assets/case/img (1).png"),
    //       centerTitle: "帛萦芝造品牌设计",
    //       centerText: "品牌设计",
    //       rightImg: require("@/assets/case/img (13).png"),
    //       rightTitle: "喜誉居品牌设计",
    //       rightText: "品牌设计",
    //     };
    //     break;
    //   case 2:
    //     this.infoData = {
    //       enTitle: "SYSTEM",
    //       cnTitle: "系统开发",
    //       centerImg: require("@/assets/case/img (9).png"),
    //       centerTitle: "局气-会员",
    //       centerText: "系统开发",
    //       rightImg: require("@/assets/case/img (6).png"),
    //       rightTitle: "电力督办管理系统",
    //       rightText: "系统开发",
    //     };
    //     break;
    //   case 3:
    //     this.infoData = {
    //       enTitle: "WEBSITE",
    //       cnTitle: "高端网站 定制开发",
    //       centerImg: require("@/assets/case/img (12).png"),
    //       centerTitle: "首都机场航空服务产教融合信息平台",
    //       centerText: "网站开发",
    //       rightImg: require("@/assets/case/img (10).png"),
    //       rightTitle: "德武龙传承教育",
    //       rightText: "网站开发",
    //     };
    //     break;
    // }
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
